import { DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutTableStops extends Layout {
	sourceCustomerOrderDetail: DataSource;
	sourceOrderStops: DataSource;
	tableStops: Table;
}
